var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-content"},[_c('UserInfo'),_c('nav',{staticClass:"sidebar-nav"},[_vm._l((_vm.menuItems),function(item,index){return _c('MenuItem',_vm._b({key:index,on:{"close":_vm.toggleMenu}},'MenuItem',item,false))}),_c('div',{staticClass:"sidebar-nav-footer"},[_c('AppFooter')],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }